export const api_url = `${process.env.REACT_APP_SERVICE_API}/api/admin`
export const api_url_v1 = `${process.env.REACT_APP_SERVICE_API}/api/v1/admin`
export const api_sanctum = process.env.REACT_APP_SERVICE_API

export const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
  
    // Function to add ordinal suffix (st, nd, rd, th)
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return 'th';
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
  
    const month = date.toLocaleString('default', { month: 'short' }); // Nov
    const year = date.getFullYear(); // 2024
  
    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };
  